/**CORE LIBRARIES IMPORT */
import React from "react";

/**
 * Turkish national flag, official 3:2 proportions and colour (#E30A17),
 * same reference geometry as TurkishEmblem. Rendered as vector, not a photo.
 */
const TurkishFlag = ({ className = "", title = "Flag of Türkiye" }) => (
  <svg
    className={`turkish-flag ${className}`}
    viewBox="0 -30000 90000 60000"
    role="img"
    aria-label={title}
  >
    <rect x="0" y="-30000" width="90000" height="60000" fill="#E30A17" />
    <path
      fill="#fff"
      d="m41750 0 13568-4408-8386 11541V-7133l8386 11541zm925 8021a15000 15000 0 1 1 0-16042 12000 12000 0 1 0 0 16042z"
    />
  </svg>
);

export default TurkishFlag;
